<template>
  <div
    class="bind-tip-box"
  >
    <div class="bind-tip-con">
      <i class="icon iconfont iconicon-test1 fail-icon" />
      <h2>{{ $t('message["1278"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="typeError===104 ">
          {{ $t('message["1407"]') }}。
        </template>
        <!-- <template v-else>
          <template v-if="bindType==='mobile'">
            失败原因：手机号码 {{ value }}  已经绑定其他企业微信/钉钉。
          </template>
          <template v-else-if="bindType==='email'">
            失败原因：邮箱 {{ value }}   已经绑定其他企业微信/钉钉。
          </template>
          <template v-else-if="bindType==='user'">
            失败原因：登录帐号 {{ value }}  已经绑定其他企业微信/钉钉。
          </template>
        </template> -->
        <div class="back-account-info">
          <router-link :to="{name: 'AccountInfo'}">
            {{ $t('message["282"]') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    typeError: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    typeName () {
      return this.typeError.payload.bindtype === 1 ? this.$t('message["720"]') : this.$t('message["238"]')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip-box .icon-tixing {
  color: #f57676 !important;
}
.bind-tip-box {
  height: 100%;
  width: 100%;
  background:  #fff;

  .bind-tip-con {
    padding: 80px 48px;
    text-align: center;
    h2 {
      font-size: 18px;
      padding: 20px 0;
    }
    .d-tip-con {
      font-size: 15px;
      color: #808080;
      line-height: 24px;
      .back-account-info {
        height: 46px;
        line-height: 46px;
        margin-top: 20px;
      }
    }
  }
  i {
      font-size: 40px;
      color: #F57676;
      margin: 0 auto;
    }
}
</style>
